"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalPropTypes = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _interfaces = require("./interfaces");

var modalPropTypes = {
  children: _stencilReactDesc.PropTypes.node.isRequired.description('Content to display as a modal.'),
  isOpen: _stencilReactDesc.PropTypes.bool.description('Whether the modal is currently open, i.e. whether the content is visible.'),
  // This should be .isRequired but that would show a warning if null is passed
  // https://github.com/facebook/react/issues/3163
  close: _stencilReactDesc.PropTypes.func.isRequired.description('Function called when the user performs an action which should close the modal.').format('(() => void) | null'),
  shouldCloseOnClickOutside: _stencilReactDesc.PropTypes.bool.description('Whether the modal can be closed by clicking outside of it.'),
  style: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.ModalStyle)).description('The visual style used to present the modal content on screen.'),
  'aria-labelledby': _stencilReactDesc.PropTypes.string.description('The id of a DOM element containing a label for the modal.'),
  'aria-describedby': _stencilReactDesc.PropTypes.string.description('The id of a DOM element containing a description for the modal.'),
  isScrollable: _stencilReactDesc.PropTypes.bool.description('Toggles whether the content of the modal is scrollable.')
};
exports.modalPropTypes = modalPropTypes;